import { clearSharedReadResources } from './readResource';

/** Source accounts have a lifetime independent of the Unity login and report revisions. */
export const SOURCE_IDENTITY_CHANGED = 'unity-source-identity-changed';
type IdentityChange = { identityKey?: string; connected: boolean };
let generation = 0;
export const sourceIdentityGeneration = () => generation;

const deliver = (change: IdentityChange) => {
    generation += 1;
    clearSharedReadResources();
    window.dispatchEvent(new CustomEvent(SOURCE_IDENTITY_CHANGED, { detail: change }));
};
const channel = typeof window.BroadcastChannel === 'function' ? new BroadcastChannel(SOURCE_IDENTITY_CHANGED) : null;
if (channel) channel.onmessage = event => {
    if (typeof event.data?.connected === 'boolean') deliver(event.data);
};
else window.addEventListener('storage', event => {
    if (event.key !== SOURCE_IDENTITY_CHANGED || !event.newValue) return;
    try { const change = JSON.parse(event.newValue); if (typeof change.connected === 'boolean') deliver(change); } catch { /* Ignore unrelated/malformed notifications. */ }
});

export const publishSourceIdentityChange = (change: IdentityChange) => {
    deliver(change);
    if (channel) channel.postMessage(change);
    else try { localStorage.setItem(SOURCE_IDENTITY_CHANGED, JSON.stringify({ ...change, nonce: Math.random() })); } catch { /* Storage may be unavailable. Local invalidation still applies. */ }
};
